/* Henne · product page helpers (theme 2027).
 * 1. Fit check (snippets/henne-pdp-fitment.liquid, mode check): compares the product's bike collections with the
 *    bike saved by the Harley finder (localStorage henne_ymm_bike) and offers an inline Year/Family/Model picker.
 * 2. Fitment list filter (mode list).
 * 3. Deposit summary (snippets/henne-pdp-deposit.liquid): follows the variant and Downpay's deposit / pay-in-full choice.
 * 1b. Merged products: variant-level fit (custom.fit_bikes via ?view=hn-fit) picks the version that fits the saved bike.
 * 5. Long dropdown choices: a dropdown whose longest choice does not fit its half-width column gets its own row. */
(function () {
  if (window.HennePdp) return;

  var STORAGE_KEY = "henne_ymm_bike";
  var indexPromise = null;

  function readBike() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var bike = raw ? JSON.parse(raw) : null;
      return bike && bike.handle && bike.model ? bike : null;
    } catch (e) {
      return null;
    }
  }

  function saveBike(bike) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(bike));
    } catch (e) {}
  }

  function loadIndex(url) {
    if (!indexPromise) {
      indexPromise = fetch(url, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("index " + r.status);
          return r.json();
        })
        .catch(function (e) {
          indexPromise = null;
          throw e;
        });
    }
    return indexPromise;
  }

  function fill(select, placeholder, values) {
    select.replaceChildren();
    var empty = document.createElement("option");
    empty.value = "";
    empty.textContent = placeholder;
    select.append(empty);
    values.forEach(function (v) {
      var o = document.createElement("option");
      o.value = String(v);
      o.textContent = String(v);
      select.append(o);
    });
    select.disabled = values.length === 0;
  }

  /* ---------- 1. Fit check ---------- */
  function initFitCheck(root) {
    if (root.dataset.hnReady) return;
    root.dataset.hnReady = "1";
    var data = root.querySelector("[data-hn-bikes]");
    var bikes = {};
    try {
      JSON.parse(data.textContent).forEach(function (h) { bikes[h] = true; });
    } catch (e) {
      return;
    }
    var states = root.querySelectorAll("[data-hn-state]");
    var picker = root.querySelector("[data-hn-fit-picker]");
    var status = root.querySelector("[data-hn-pick-status]");
    var openers = root.querySelectorAll("[data-hn-fit-open]");
    var pick = {
      year: root.querySelector('[data-hn-pick="year"]'),
      family: root.querySelector('[data-hn-pick="family"]'),
      model: root.querySelector('[data-hn-pick="model"]'),
    };
    var index = null;

    function label(bike) {
      return bike.year + " " + bike.model;
    }

    function show(name, bike) {
      states.forEach(function (el) { el.hidden = el.dataset.hnState !== name; });
      if (bike) {
        root.querySelectorAll("[data-hn-bike-label]").forEach(function (el) { el.textContent = label(bike); });
        var parts = root.querySelector("[data-hn-bike-parts]");
        if (parts) {
          parts.href = root.dataset.collectionsUrl.replace(/\/?$/, "/") + encodeURIComponent(bike.handle);
          parts.textContent = "See parts that fit your " + label(bike);
          parts.hidden = name !== "no";
        }
      }
    }

    /* Variant-level fit (products merged from split-by-model products, variants carry custom.fit_bikes).
     * With a saved bike: load the variant map (?view=hn-fit), select the version that fits (keeping the other
     * choices such as the finish where possible), mark the fitting choices in the dropdowns and say which version
     * fits. A link to a specific ?variant= is respected: no auto switch, only the note. */
    var vfitUrl = root.dataset.variantFitUrl;
    var note = root.querySelector("[data-hn-variant-note]");
    var section = root.closest(".shopify-section") || document;
    var explicitVariant = /[?&]variant=\d+/.test(window.location.search);
    var MARK = " ✓ fits your bike";
    var vfit = null;
    var vfitLoading = null;

    function loadVariantFit() {
      if (!vfitLoading) {
        vfitLoading = fetch(vfitUrl, { credentials: "same-origin" })
          .then(function (r) {
            if (!r.ok) throw new Error("fit " + r.status);
            return r.text();
          })
          .then(function (text) {
            var d = JSON.parse(text);
            d.variants.forEach(function (v) {
              v.fits = {};
              (v.bikes || []).forEach(function (h) { v.fits[h] = true; });
            });
            vfit = d;
            return d;
          })
          .catch(function () {
            vfitLoading = null;
            return null;
          });
      }
      return vfitLoading;
    }

    function currentVariant() {
      var form = section.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('[name="id"]');
      if (!vfit || !input) return null;
      return vfit.variants.filter(function (v) { return String(v.id) === String(input.value); })[0] || null;
    }

    function optionSelect(i) {
      var name = "options[" + vfit.options[i] + "]";
      var selects = section.querySelectorAll(".main-product__block-variant_picker select");
      for (var k = 0; k < selects.length; k++) if (selects[k].name === name) return selects[k];
      return null;
    }

    function selectVariant(v) {
      v.options.forEach(function (value, i) {
        var select = optionSelect(i);
        if (select && select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    function bestFit(bike, cur) {
      var same = function (v) {
        var s = 0;
        if (cur) v.options.forEach(function (o, i) { if (o === cur.options[i]) s++; });
        return s;
      };
      return vfit.variants
        .filter(function (v) { return v.fits[bike.handle]; })
        .sort(function (a, b) { return same(b) - same(a); })[0] || null;
    }

    // Add "✓ fits your bike" to the dropdown choices that fit, on options where not every choice fits.
    function markOptions(bike) {
      if (!vfit) return;
      vfit.options.forEach(function (name, i) {
        var select = optionSelect(i);
        if (!select) return;
        var fitting = {};
        if (bike) vfit.variants.forEach(function (v) { if (v.fits[bike.handle]) fitting[v.options[i]] = true; });
        var all = Array.prototype.every.call(select.options, function (o) { return fitting[o.value]; });
        Array.prototype.forEach.call(select.options, function (o) {
          var base = o.getAttribute("data-hn-text");
          if (base === null) {
            base = o.text;
            o.setAttribute("data-hn-text", base);
          }
          var text = bike && !all && fitting[o.value] ? base + MARK : base;
          if (o.text !== text) o.text = text;
        });
      });
    }

    function updateNote(bike) {
      if (!note) return;
      var cur = currentVariant();
      if (!vfit || !bike || !bikes[bike.handle] || !cur || !cur.bikes) {
        note.hidden = true;
        return;
      }
      note.replaceChildren();
      var chosen = cur.options.join(", ");
      if (cur.fits[bike.handle]) {
        note.className = "hn-fitcheck__variant hn-fitcheck__variant--ok";
        note.textContent = "Selected version (" + chosen + ") is the one for your bike.";
      } else {
        var best = bestFit(bike, cur);
        note.className = "hn-fitcheck__variant hn-fitcheck__variant--warn";
        note.append(document.createTextNode("Selected version (" + chosen + ") does not fit your " + label(bike) + "."));
        if (best) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hn-fitcheck__link";
          button.textContent = "Switch to " + best.options.join(", ");
          button.addEventListener("click", function () { selectVariant(best); });
          note.append(" ", button);
        }
      }
      note.hidden = false;
    }

    // The theme's <variant-picker> listens for option changes only after its async setupData() has loaded the
    // product JSON (it sets picker.productData, then adds the listener in the same tick). Changing a select earlier
    // updates the dropdown but not the variant, so wait for productData (max ~6 s, then go ahead anyway).
    function pickerReady() {
      return new Promise(function (resolve) {
        var tries = 0;
        (function check() {
          var picker = section.querySelector("variant-picker");
          if (!picker || picker.productData || tries++ > 60) return resolve();
          window.setTimeout(check, 100);
        })();
      });
    }

    function applyVariantFit(auto) {
      if (!vfitUrl) return;
      var bike = readBike();
      if (!bike || !bikes[bike.handle]) {
        if (note) note.hidden = true;
        markOptions(null);
        return;
      }
      Promise.all([loadVariantFit(), pickerReady()]).then(function (r) {
        var d = r[0];
        if (!d) return;
        var cur = currentVariant();
        if (auto && cur && cur.bikes && !cur.fits[bike.handle]) {
          var best = bestFit(bike, cur);
          if (best) selectVariant(best);
        }
        markOptions(bike);
        window.setTimeout(function () { updateNote(bike); }, 0);
      });
    }

    if (vfitUrl) {
      section.addEventListener("change", function (event) {
        var t = event.target;
        var isOption = t && t.tagName === "SELECT" && (t.name || "").indexOf("options[") === 0;
        var isVariantId = t && t.name === "id";
        if (!isOption && !isVariantId) return;
        window.setTimeout(function () {
          var bike = readBike();
          if (!vfit || !bike || !bikes[bike.handle]) return;
          markOptions(bike);
          updateNote(bike);
        }, 0);
      });
    }

    function render(auto) {
      var bike = readBike();
      if (!bike) show("unknown");
      else show(bikes[bike.handle] ? "yes" : "no", bike);
      applyVariantFit(auto);
    }

    function setOpen(open) {
      picker.hidden = !open;
      openers.forEach(function (b) { b.setAttribute("aria-expanded", open ? "true" : "false"); });
    }

    function families() {
      var y = index && index.y[pick.year.value];
      if (!y) return [];
      var order = index.families || [];
      var rank = function (f) { var i = order.indexOf(f); return i === -1 ? order.length : i; };
      return Object.keys(y).sort(function (a, b) { return rank(a) - rank(b) || a.localeCompare(b); });
    }

    function models() {
      var y = index && index.y[pick.year.value];
      return (y && y[pick.family.value]) || [];
    }

    function preselect() {
      var bike = readBike();
      fill(pick.year, "Year", index.years);
      if (bike && index.y[bike.year]) {
        pick.year.value = String(bike.year);
        fill(pick.family, "Family", families());
        pick.family.value = bike.family || "";
        fill(pick.model, "Model", models().map(function (e) { return e.m; }));
        pick.model.value = bike.model || "";
      } else {
        fill(pick.family, "Family", []);
        fill(pick.model, "Model", []);
      }
    }

    function open() {
      setOpen(true);
      if (index) {
        preselect();
        pick.year.focus();
        return;
      }
      status.hidden = false;
      status.textContent = "Loading motorcycles…";
      loadIndex(root.dataset.indexUrl)
        .then(function (d) {
          index = d;
          status.hidden = true;
          preselect();
          pick.year.focus();
        })
        .catch(function () {
          status.textContent = "Could not load motorcycles. Please try again.";
        });
    }

    openers.forEach(function (b) {
      b.addEventListener("click", function () {
        if (picker.hidden) open();
        else setOpen(false);
      });
    });

    // Keep the previous value when it still exists (e.g. only the year changed), else auto-pick a single option.
    function refill(select, placeholder, values) {
      var prev = select.value;
      fill(select, placeholder, values);
      if (values.indexOf(prev) !== -1) select.value = prev;
      else if (values.length === 1) select.value = values[0];
    }

    function commit() {
      var entry = models().filter(function (e) { return e.m === pick.model.value; })[0];
      if (!entry) return;
      saveBike({ year: pick.year.value, family: pick.family.value, model: entry.m, handle: entry.h });
      setOpen(false);
      render(true);
      var focusTarget = root.querySelector("[data-hn-state]:not([hidden]) [data-hn-fit-open]");
      if (focusTarget) focusTarget.focus();
    }

    picker.addEventListener("change", function (event) {
      var field = event.target.dataset.hnPick;
      if (!field || !index) return;
      if (field === "year") refill(pick.family, "Family", families());
      if (field === "year" || field === "family") {
        refill(pick.model, "Model", pick.family.value ? models().map(function (e) { return e.m; }) : []);
      }
      if (pick.model.value) commit();
    });

    window.addEventListener("storage", function (event) {
      if (event.key === STORAGE_KEY) render(true);
    });
    render(!explicitVariant);
  }

  /* ---------- 2. Fitment list filter ---------- */
  function initFitList(root) {
    if (root.dataset.hnReady) return;
    root.dataset.hnReady = "1";
    var more = root.querySelector("[data-hn-fit-more]");
    if (more) {
      more.addEventListener("click", function () {
        root.classList.remove("hn-fit--collapsed");
        more.hidden = true;
        more.setAttribute("aria-expanded", "true");
      });
    }
    var input = root.querySelector("[data-hn-fit-filter]");
    if (!input) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-hn-fit-row]"));
    var empty = root.querySelector("[data-hn-fit-empty]");
    input.addEventListener("input", function () {
      var words = input.value.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      root.classList.toggle("hn-fit--filtering", words.length > 0);
      rows.forEach(function (row) {
        var text = row.textContent.toLowerCase();
        var ok = words.every(function (w) { return text.indexOf(w) !== -1; });
        row.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* ---------- 3. Deposit summary ---------- */
  function initDeposit(root) {
    if (root.dataset.hnReady) return;
    root.dataset.hnReady = "1";
    var variants = {};
    try {
      JSON.parse(root.querySelector("[data-hn-deposit-variants]").textContent).forEach(function (v) {
        variants[String(v.id)] = v;
      });
    } catch (e) {
      return;
    }
    var form = document.getElementById(root.dataset.formId);
    var planId = String(root.dataset.planId);
    var lines = {
      deposit: root.querySelector('[data-hn-deposit-mode="deposit"]'),
      full: root.querySelector('[data-hn-deposit-mode="full"]'),
    };
    var out = {
      today: root.querySelector("[data-hn-deposit-today]"),
      later: root.querySelector("[data-hn-deposit-later]"),
      full: root.querySelector("[data-hn-deposit-full]"),
    };

    function update() {
      if (!form) form = document.getElementById(root.dataset.formId);
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var v = idInput && variants[idInput.value];
      var planInput = form.querySelector('[name="selling_plan"]');
      var onDeposit = !!(planInput && planInput.value && String(planInput.value) === planId);
      if (!v) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      out.today.textContent = v.today;
      out.later.textContent = v.later;
      out.full.textContent = v.full;
      lines.deposit.hidden = !onDeposit;
      lines.full.hidden = onDeposit;
    }

    document.addEventListener("change", function () { window.setTimeout(update, 0); });
    document.addEventListener("theme:variant:change", function () { window.setTimeout(update, 0); });
    if (form && window.MutationObserver) {
      new MutationObserver(update).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ["value"] });
    }
    update();
    // Downpay adds its hidden input after its script loads; re-check once things settle.
    window.setTimeout(update, 1500);
  }

  /* ---------- 4. Downpay: "Pay in full" first, then the deposit ----------
   * Downpay renders its radios with JS (deposit first); move the pay-in-full option up in the DOM so the visual,
   * keyboard and screen-reader order match. Re-applied whenever Downpay re-renders. */
  function orderPayOptions(block) {
    if (block.dataset.hnPayOrder) return;
    block.dataset.hnPayOrder = "1";
    function apply() {
      var full = block.querySelector("#purchase-option-full-wrapper");
      var deposit = block.querySelector("#purchase-option-deposit-wrapper");
      if (!full || !deposit || full.parentNode !== deposit.parentNode) return;
      if (deposit.compareDocumentPosition(full) & Node.DOCUMENT_POSITION_FOLLOWING) {
        deposit.parentNode.insertBefore(full, deposit);
      }
    }
    apply();
    if (window.MutationObserver) new MutationObserver(apply).observe(block, { childList: true, subtree: true });
  }

  /* ---------- 5. Long dropdown choices get their own row ----------
   * henne-pdp.css shows two dropdowns per row on desktop. When the longest choice of a dropdown does not fit its
   * half-width select, that option moves to a full-width row (class hn-opt--wide) so the text is not cut off.
   * Re-checked on resize, after web fonts load and when the theme re-renders the picker. */
  var measureCtx = null;
  function textWidth(text, font) {
    if (!measureCtx) measureCtx = document.createElement("canvas").getContext("2d");
    measureCtx.font = font;
    return measureCtx.measureText(text).width;
  }

  function fitOptions(block) {
    var picker = block.querySelector("variant-picker");
    if (!picker) return;
    var opts = Array.prototype.filter.call(picker.children, function (el) {
      return el.classList.contains("m-product-option--dropdown");
    });
    opts.forEach(function (opt) { opt.classList.remove("hn-opt--wide"); });
    if (opts.length < 2 || window.getComputedStyle(picker).display !== "grid") return; // phones: one column already
    opts.forEach(function (opt) {
      var select = opt.querySelector("select");
      if (!select || !select.clientWidth) return;
      var cs = window.getComputedStyle(select);
      var font = cs.fontStyle + " " + cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
      var room = select.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0) - 4;
      var widest = 0;
      Array.prototype.forEach.call(select.options, function (o) {
        widest = Math.max(widest, textWidth(o.text, font));
      });
      if (widest > room) opt.classList.add("hn-opt--wide");
    });
  }

  function initOptionFit(block) {
    if (block.dataset.hnOptFit) return;
    block.dataset.hnOptFit = "1";
    var timer = null;
    function run() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { fitOptions(block); }, 60);
    }
    fitOptions(block);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    window.addEventListener("resize", run);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].type === "childList") { run(); return; }
        }
      }).observe(block, { childList: true, subtree: true });
    }
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll("#downpay-block, .downpay-block").forEach(orderPayOptions);
    s.querySelectorAll("[data-hn-fitcheck]").forEach(initFitCheck);
    s.querySelectorAll("[data-hn-fit-list]").forEach(initFitList);
    s.querySelectorAll("[data-hn-deposit]").forEach(initDeposit);
    s.querySelectorAll(".main-product__block-variant_picker").forEach(initOptionFit);
  }

  window.HennePdp = { initAll: initAll };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
